import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-validation-animation',
  templateUrl: './validation-animation.component.html',
  styleUrls: ['./validation-animation.component.scss'],

})
export class ValidationAnimationComponent implements OnInit {
  @Input() text!: string;

  constructor() { }


  ngOnInit(): void { }

}
